module.exports = __webpack_public_path__ + "static/media/logoKenetto-01.44839a8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logoKenetto-01.svg
// module id = 979
// module chunks = 0